// @generated by TypeGen from LogbookApi/NMEAApi - DO NOT EDIT

import type { INMEAConnectRequest, INMEAResponse, INMEAUpdateRequest } from "../LogbookApp/NMEAApi"
import type { IAppResponse } from "../LogbookApp/Routes"
import { IShipUserLevel } from "../LogbookModel/ShipUser"
import { assertTarget } from "./ApiRuntime"
import type { ApiArgs, ApiClient, ApiTarget, ApiUser } from "./ApiRuntime"

export interface NMEAApiEndpoints {
  "DELETE /api/nmea": {
    params: {};
    query: {};
    request: never;
    response: IAppResponse;
    targets: ApiTarget[];
    permission: { ship: IShipUserLevel };
  };
  "DELETE /api/nmea/baro": {
    params: {};
    query: {};
    request: never;
    response: IAppResponse;
    targets: ApiTarget[];
    permission: { ship: IShipUserLevel };
  };
  "GET /api/nmea": {
    params: {};
    query: {};
    request: never;
    response: INMEAResponse;
    targets: ApiTarget[];
    permission: { ship: IShipUserLevel };
  };
  "POST /api/nmea": {
    params: {};
    query: {};
    request: INMEAConnectRequest;
    response: IAppResponse;
    targets: ApiTarget[];
    permission: { ship: IShipUserLevel };
  };
  "PUT /api/nmea": {
    params: {};
    query: {};
    request: INMEAUpdateRequest;
    response: IAppResponse;
    targets: ApiTarget[];
    permission: { ship: IShipUserLevel };
  };
  "PUT /api/nmea/baro": {
    params: {};
    query: {};
    request: never;
    response: IAppResponse;
    targets: ApiTarget[];
    permission: { ship: IShipUserLevel };
  };
}

export const nMEAApiEndpoints = {
  "DELETE /api/nmea": { targets: ["app"], permission: { ship: IShipUserLevel.primary } },
  "DELETE /api/nmea/baro": { targets: ["app"], permission: { ship: IShipUserLevel.primary } },
  "GET /api/nmea": { targets: ["app"], permission: { ship: IShipUserLevel.primary } },
  "POST /api/nmea": { targets: ["app"], permission: { ship: IShipUserLevel.primary } },
  "PUT /api/nmea": { targets: ["app"], permission: { ship: IShipUserLevel.primary } },
  "PUT /api/nmea/baro": { targets: ["app"], permission: { ship: IShipUserLevel.primary } },
} as const;

export class NMEAApi {
  constructor(private client: ApiClient) {}

  nmea = {
    disconnect: (a: ApiArgs<NMEAApiEndpoints, "DELETE /api/nmea">) => ({
      call: (): Promise<IAppResponse> => {
        assertTarget(this.client, "DELETE /api/nmea", nMEAApiEndpoints["DELETE /api/nmea"].targets);
        return this.client.call<IAppResponse>("DELETE /api/nmea", a);
      },
      url: (): string => this.client.url("DELETE /api/nmea", a),
      available: (user?: ApiUser): boolean => user != null && (user.shipLevel() ?? -1) >= IShipUserLevel.primary,
    }),
    disableBaro: (a: ApiArgs<NMEAApiEndpoints, "DELETE /api/nmea/baro">) => ({
      call: (): Promise<IAppResponse> => {
        assertTarget(this.client, "DELETE /api/nmea/baro", nMEAApiEndpoints["DELETE /api/nmea/baro"].targets);
        return this.client.call<IAppResponse>("DELETE /api/nmea/baro", a);
      },
      url: (): string => this.client.url("DELETE /api/nmea/baro", a),
      available: (user?: ApiUser): boolean => user != null && (user.shipLevel() ?? -1) >= IShipUserLevel.primary,
    }),
    get: (a: ApiArgs<NMEAApiEndpoints, "GET /api/nmea">) => ({
      call: (): Promise<INMEAResponse> => {
        assertTarget(this.client, "GET /api/nmea", nMEAApiEndpoints["GET /api/nmea"].targets);
        return this.client.call<INMEAResponse>("GET /api/nmea", a);
      },
      url: (): string => this.client.url("GET /api/nmea", a),
      available: (user?: ApiUser): boolean => user != null && (user.shipLevel() ?? -1) >= IShipUserLevel.primary,
    }),
    connect: (a: ApiArgs<NMEAApiEndpoints, "POST /api/nmea">) => ({
      call: (): Promise<IAppResponse> => {
        assertTarget(this.client, "POST /api/nmea", nMEAApiEndpoints["POST /api/nmea"].targets);
        return this.client.call<IAppResponse>("POST /api/nmea", a);
      },
      url: (): string => this.client.url("POST /api/nmea", a),
      available: (user?: ApiUser): boolean => user != null && (user.shipLevel() ?? -1) >= IShipUserLevel.primary,
    }),
    update: (a: ApiArgs<NMEAApiEndpoints, "PUT /api/nmea">) => ({
      call: (): Promise<IAppResponse> => {
        assertTarget(this.client, "PUT /api/nmea", nMEAApiEndpoints["PUT /api/nmea"].targets);
        return this.client.call<IAppResponse>("PUT /api/nmea", a);
      },
      url: (): string => this.client.url("PUT /api/nmea", a),
      available: (user?: ApiUser): boolean => user != null && (user.shipLevel() ?? -1) >= IShipUserLevel.primary,
    }),
    enableBaro: (a: ApiArgs<NMEAApiEndpoints, "PUT /api/nmea/baro">) => ({
      call: (): Promise<IAppResponse> => {
        assertTarget(this.client, "PUT /api/nmea/baro", nMEAApiEndpoints["PUT /api/nmea/baro"].targets);
        return this.client.call<IAppResponse>("PUT /api/nmea/baro", a);
      },
      url: (): string => this.client.url("PUT /api/nmea/baro", a),
      available: (user?: ApiUser): boolean => user != null && (user.shipLevel() ?? -1) >= IShipUserLevel.primary,
    }),
  };
}
